<template>
  <div>
    <Row>
      <Col span="11">
        <FormItem :label="$t('resourceLifecycle.name')" prop="name">
          <Input v-model="resourceApplicationForm.name" :placeholder="$t('resourceLifecycle.pleaseEnter')"/>
        </FormItem>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: 'AmazonElasticAddress',
    props: ['amazonResourceApplicationBasicInfoForm', 'cost'],
    components: {},
    data() {
      return {
        resourceApplicationForm: {
          name: '',
          cost: 0
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t("resourceLifecycle.namecannotbeempty"), trigger: 'blur'}
          ]
        }
      }
    },
    mounted: function () {
    },
    methods: {
      //查询价格
      queryAWSEipPrice: function () {
        var submitLifecycleResourceApplicationDTO = {
          "duration": this.amazonResourceApplicationBasicInfoForm.periodOfUse,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        }
        this.$api.awsPrice.queryAWSEipPrice(submitLifecycleResourceApplicationDTO)
          .then(res => {
            this.resourceApplicationForm.cost = res.data
            this.$emit('success', this.resourceApplicationForm.cost);
          })
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/aws/elastic_ip/AmazonElasticAddress.vue